export enum EAsyncStateStatus {
  Awaiting = 'Awaiting',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Resolved = 'Resolved',
}

export type TAwaitingAsyncState = [
  undefined,
  {
    status: EAsyncStateStatus.Awaiting;
    error: null;
    isAwaiting: true;
    isPending: false;
    isRejected: false;
    isResolved: false;
  },
];

export type TPendingAsyncState<DataType> = [
  DataType | undefined,
  {
    status: EAsyncStateStatus.Pending;
    error: null;
    isAwaiting: false;
    isPending: true;
    isRejected: false;
    isResolved: false;
  },
];

export type TResolvedAsyncState<DataType> = [
  DataType,
  {
    status: EAsyncStateStatus.Resolved;
    error: null;
    isAwaiting: false;
    isPending: false;
    isRejected: false;
    isResolved: true;
  },
];

export type TRejectedAsyncState<ErrorType = Error> = [
  undefined,
  {
    status: EAsyncStateStatus.Rejected;
    error: ErrorType;
    isAwaiting: false;
    isPending: false;
    isRejected: true;
    isResolved: false;
  },
];

export type TAsyncState<DataType, ErrorType = Error> =
  | TAwaitingAsyncState
  | TPendingAsyncState<DataType>
  | TResolvedAsyncState<DataType>
  | TRejectedAsyncState<ErrorType>;

export interface IUseAsyncStateResult<DataType, ErrorType = Error> {
  state: TAsyncState<DataType, ErrorType>;
  markAsPending: () => void;
  markAsRejected: (error: ErrorType) => void;
  markAsResolved: (data: DataType) => void;
  reset: () => void;
}
